import { ButtonBase } from "@mui/material";
import React from "react";

function AddOnCard({
  addOn,
  isSelected,
  onSelect,
  disabled = true,
  currencySymbol,
  handleUnitIncrease = () => {},
}: any) {
  return (
    <div
      className={`rounded-2xl cursor-pointer w-[14.0625rem] h-[9.375rem] flex border-4 ${
        isSelected ? "border-[#6BBBE3]" : "border-transparent"
      }`}
    >
      <ButtonBase
        component="div"
        className={"rounded-2xl"}
        onClick={() => onSelect(addOn.itemId)}
        style={{
          boxSizing: "border-box",
          boxShadow: "0 0 0.625rem rgba(0, 0, 0, 0.1), 0.375rem 0.375rem 0.75rem rgba(0, 0, 0, 0.1)",
        }}
        disabled={disabled}
      >
        <div className="gap-2.5 flex items-start flex-col m-4 overflow-auto ">
          <div className="text-lg font-semibold">{addOn.name}</div>
          <div className="flex gap-2 h-6">
            {addOn.pricing_scheme == "unit" && (
              <>
                <input
                  style={{
                    outline: "none",
                  }}
                  className="border border-text_light text-text_light rounded-sm px-2 py-1 w-12"
                  min="0"
                  type="number"
                  value={addOn.quantity}
                  onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
                  onChange={(e) => handleUnitIncrease(e, addOn)}
                  disabled={disabled}
                />
                <div className="flex items-center">{"×"}</div>
              </>
            )}

            <div className="flex items-center text-xs font-semibold">
              {currencySymbol} {addOn.price.toLocaleString("en-IN")}
              {addOn.pricing_scheme === "unit" && ` / ${addOn.unit_name || addOn.unit}`}
              {addOn.type === "recurring" && " / year"}
            </div>
          </div>
          <div className="text-xs flex text-gray-500 text-start">{addOn.description}</div>
        </div>
      </ButtonBase>
    </div>
  );
}

AddOnCard.defaultProps = {
  isSelected: false,
  onSelect: () => {},
  disabled: true,
  currencySymbol: "₹",
  handleUnitIncrease: () => {},
};

export default AddOnCard;
